/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import toast from "react-hot-toast";
import { CREATE_MULTI_BOX } from "../graphql/createMultiBox.mutation";
import { MULTI_REG_BOX } from "../graphql/multiregisterBox.mutation";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateMultiBoxMethods extends IPluginMethodMap {
  CreateMultiBox(args: any): Promise<any>;
}

export class CreateMultiBoxService implements IAgentPlugin {
  readonly methods: ICreateMultiBoxMethods;

  constructor() {
    this.methods = {
      CreateMultiBox: this.CreateMultiBox.bind(this),
    };
  }

  async CreateMultiBox(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      console.log(
        "args12345create",
        args,
        this.transformData(args?.createMulti),
      );
      if (client) {
        let variables: any = {
          data: this.transformData(args?.createMulti),
        };
        const res = await client.mutate({
          mutation: CREATE_MULTI_BOX,
          variables: variables,
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          let variables1 = this.transformResData(args?.event, args?.items, res);
          console.log("args12345create", variables1);
          const res1 = await client.mutate({
            mutation: MULTI_REG_BOX,
            variables: variables1,
            fetchPolicy: "no-cache",
          });
          if (res1?.data) {
            const paymentUrl =
              res1?.data?.multiRegisterPayment?.data?.session[
                "payment-hosted-url"
              ];
            if (paymentUrl) {
              window.location.href = paymentUrl;
              console.log(`Redirecting to: ${paymentUrl}`);
              return {
                ...res1?.data?.multiRegisterPayment,
                redirection: true,
              };
            }
            toast.success("Costumes Created !");
            return {
              ...res1?.data?.multiRegisterPayment,
              redirection: false,
            };
          }
          toast.error("Box created but payment failed!");
          return true;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private transformResData(event: any, items: any[], res1: any) {
    const createdBoxes = res1?.data?.createMultiBox ?? [];
    const groupId = createdBoxes?.[0]?.groupId;

    const allAllocations = event?.allocations ?? [];

    const splitMap = createdBoxes.map((entry: any, index: number) => {
      const sourceItem = items?.[index];

      const boxCostumeValueIds =
        entry?.payOrder?.box?.[0]?.items
          ?.map((item: any) => {
            return (
              item?.costumeValue?.id ?? item?.costumeValue ?? item?.value?.id
            );
          })
          ?.filter(Boolean) ?? [];

      let boxAllocations = allAllocations.filter((allocation: any) =>
        boxCostumeValueIds.includes(allocation?.costumeValueId),
      );

      // The response may not return box item details.
      // For a single Open Registration costume, use all allocations.
      if (createdBoxes.length === 1 && boxAllocations.length === 0) {
        boxAllocations = allAllocations;
      }

      const allocationAmount = boxAllocations.reduce(
        (total: number, allocation: any) =>
          total + Number(allocation?.amount ?? 0),
        0,
      );

      const mappedItem: any = {
        amount:
          allocationAmount > 0
            ? allocationAmount
            : Number(sourceItem?.enteredAmount ?? 0),
        costumeId: entry?.payOrder?.box?.[0]?.costumeID,
        payOrder: entry?.payOrder?.id,
        allocations: boxAllocations,
      };

      if (sourceItem?.selectedDiscount) {
        mappedItem.discountCode = sourceItem.selectedDiscount;
      }

      return mappedItem;
    });

    return {
      data: {
        amount: Number(event?.amount ?? 0),
        currency: event?.currency ?? "TTD",
        groupId,
        groupPayment: true,
        splitMap,
        payorder: createdBoxes?.[0]?.payOrder?.id,
        allocations: allAllocations,
      },
    };
  }
  private transformData(inputData) {
    return inputData.map((entry) => {
      if (Array.isArray(entry.items)) {
        let data = {
          presentation: entry.presentationID,
          section: entry.sectionID,
          items: entry.items,
          referal: entry.referal,
        };
        if (entry?.availableTime) {
          data.availableTime = entry?.availableTime;
        }
        if (entry?.address) {
          data.address = entry?.address;
        }
        if (entry?.delivery) {
          data.delivery = { isOpted: entry?.delivery?.isOpted };
        } else {
          data.delivery = { isOpted: false };
        }
        return data;
      }
      let data = {
        presentation: entry.items.presentation,
        section: entry.items.section,
        items: entry.items.items,
        referal: entry.items.referal,
      };
      if (entry?.items?.availableTime) {
        data.availableTime = entry?.items?.availableTime;
      }
      if (entry?.items?.address) {
        data.address = entry?.items?.address;
      }
      if (entry?.items?.delivery) {
        data.delivery = { isOpted: entry?.items?.delivery?.isOpted };
      } else {
        data.delivery = { isOpted: false };
      }
      return data;
    });
  }
}
